import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloatTabs from "../DynamicDTFloatTabs";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import MultiSelectOptions from "./../MultiSelectOptions";
import { hst03_report_json_format, generateExcel, getHeaderColNames, transformNavDataForLabels, excelColorCodes, goFullScreen } from "../../utils";
import ProcessLoader from "../ProcessLoader";

const BI08 = () => {


    const navigate = useNavigate();
    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const allIndiaTypeDepo = depo_data.data.filter(item => item.value !== "NA"); //removed 0 from all type users
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [tabLoader, setTabLoader] = useState([]); //add product codes
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDepo, setSelectedDepo] = useState(allIndiaTypeDepo[0].value);
    const [SelectedStartMonth, setSelectedStartMonth] = useState(month_data.data[0].value);
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [productListItems, setProductListItems] = useState([]);
    const [productlistLoading, setProductlistLoading] = useState(true);
    const [SelectedProductCodes, setSelectedProductCodes] = useState([])
    const [productReportData, setProductReportdata] = useState([]);
    const [ReportType, setReportType] = useState(1);
    const [unitValue, setUnitValue] = useState(1);
    const [OPT, setOPT] = useState(4);

    const [reportGenerationCompleted, setReportGenerationCompleted] = useState(false);
    const [reportDataReady, setReportDataReady] = useState(false);
    const [MultiSheetDownloadStart, setMultiSheetDownloadStart] = useState(false);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');

    const [groupLoader, setGroupLoader] = useState(true);
    const [GroupListItems, setGroupListItems] = useState([]);
    const [SelectedGroup, setSelectedGroup] = useState(0);

    const [GroupwiseProductWiseOpt, setGroupwiseProductWiseOpt] = useState(1);




    useEffect(() => {

        if (reportGenerationCompleted) {
            setReportDataReady(true);
        }
    }, [reportGenerationCompleted]);


    useEffect(() => {
        if (reportDataReady) {

            var reportJson = {};
            var multiReportTitle = [];
            reportJson.fileName = pageTitle + "-" + SelectedYear + ".xlsx";
            //reportJson.fileName =  "Selective Product - Sales Trend (Gross)-"+SelectedYear+".xlsx";
            reportJson.title = pageTitle;
            //reportJson.title = "Selective Product - Sales Trend (Gross)";
            reportJson.author = "Aristo Pharma";
            var decimal_indexes = [];

            reportJson.sheets = [];
            productReportData.map((singlereport, index) => {

                //
                reportJson.sheets.push({
                    name: SelectedProductCodes[index].value.toString().trim(),
                    data: []
                })
                multiReportTitle.push(singlereport.data.title);

                const columns = Object.keys(singlereport.data.data[0]).filter(key => key !== 'color');
                const headerFormatted = columns.map(key => getHeaderColNames(key));

                reportJson.sheets[index].data.push({
                    backgroundColor: "#0043a9",
                    fontColor: "#FFFFFF",
                    fontSize: 13,
                    bold: true,
                    values: headerFormatted
                });

                const backgroundColors = excelColorCodes;

                singlereport.data.data.forEach(item => {
                    const row = {
                        backgroundColor: backgroundColors[item.color] || "",
                        fontColor: item.color === 2 ? "#333333" : "#333333",
                        fontSize: 12,
                        bold: false,
                        //  values: columns.map(col => item[col])
                        values: columns.map((col, colIndex) => {
                            let value = item[col];

                            if (Array.isArray(singlereport.data.decimal_keys) && singlereport.data.decimal_keys.length > 0) {
                                if (singlereport.data.decimal_keys.includes(col)) {
                                    if (!decimal_indexes.includes(colIndex)) {
                                        decimal_indexes.push(colIndex);
                                    }
                                }
                            }

                            return value;
                        })
                    };
                    reportJson.sheets[index].data.push(row);
                });
            });

            generateExcel(reportJson, 40, 20, 0, 3, multiReportTitle,decimal_indexes).catch(console.error);

            setReportDataReady(false);
            setMultiSheetDownloadStart(false);
            setReportGenerationCompleted(false);
        }
    }, [reportDataReady]);

    const handleExportSheet = async () => {

        setMultiSheetDownloadStart(true);

        if (SelectedProductCodes.length != productReportData.length) {
            await Promise.all(
                SelectedProductCodes.map(singleprod => {
                    console.log("ALL SHEET GEN");
                    return generateProductReport(singleprod.value);
                })
            );
            setReportGenerationCompleted(true);
        } else {
            setReportGenerationCompleted(true);
        }
    }


    const handleTabChange = (productCode) => {
        if (!tabLoader.includes(productCode)) {
            generateProductReport(productCode);
        } else {
        }
    }

    const generateProductReport = async (productCode) => {

        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),
            "smon": parseInt(SelectedStartMonth),
            "emon": parseInt(SelectedEndMonth),
            "code": parseInt(productCode),
            "rep_type": parseInt(ReportType),
            "uv": unitValue,
            "rep_type_pgwise": parseInt(GroupwiseProductWiseOpt),
            "opt": OPT
        }

        var reportAPIResponse = {};

        if (ReportType == 9 || ReportType == 10 || ReportType == 13) {
            reportAPIResponse = await proxy(`/api/mis/branchmisrepo8Ach`, payload, "get");
        } else {
            reportAPIResponse = await proxy(`/api/mis/branchmisrepo8`, payload, "get");
        }

        var processedReportData = [];
        if (reportAPIResponse == '') {
            processedReportData = { title: "NO DATA", data: [] };
        } else {
            processedReportData = hst03_report_json_format(reportAPIResponse);
        }

        const newProductReport = { "product_code": productCode, "data": processedReportData };
        setProductReportdata((productReportData) => {
            const index = productReportData.findIndex(p => p.product_code === newProductReport.product_code);
            if (index > -1) {
                return productReportData.map((p, i) => i === index ? newProductReport : p);
            } else {
                // Product doesn't exist, add it
                return [...productReportData, newProductReport];
            }
        });

        setTabLoader([...tabLoader, productCode]);
    }


    function convertProductData(dataAPIResponse) {
        if (dataAPIResponse && Array.isArray(dataAPIResponse.data)) {
            const converted_list = dataAPIResponse.data.map(item => ({
                value: item['value'],
                label: item['name']
            }));
            return converted_list;
        }
        return [];
    }

    const handleProductChange = (selectedProducts) => {
        if (selectedProducts.length > 5) {
            alert('Maximum of 5 products can be selected at a time. Please remove extra products.');
        } else {
            setSelectedProductCodes(selectedProducts);
        }
    }

    const loadProductItems = async (division, year) => {
        setProductlistLoading(true);
        const payload = {};
        const dataAPIResponse = await proxy(`/api/mis/productlist/${division}/${year}/0`, payload, "get", true);
        const converted_list = convertProductData(dataAPIResponse);
        setProductListItems(converted_list);
        setProductlistLoading(false);

    }


    function getTabreport(pcode) {
        const index = productReportData.findIndex(item => item.product_code === pcode);
        return productReportData[index].data;

    }
    const handleReportGen = () => {
        goFullScreen();

        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";
        if (SelectedProductCodes.length == 0) {
            alert('Select aleast one product');
            return;
        }
        generateProductReport(SelectedProductCodes[0].value);
        setShowOptions(false);
    }

    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);
    }

    const loadGroupList = async (div, year) => {
        setGroupLoader(true);
        const grouplistAPIResponse = await proxy(`/api/mis/grouplist/${div}/${year}`, {}, "get");

        const converted_list = convertProductData(grouplistAPIResponse);
        setGroupListItems(converted_list);
        setGroupLoader(false);
    }

    useEffect(() => {

        loadProductItems(SelectedDiv, SelectedYear);
        loadGroupList(SelectedDiv, SelectedYear);
        transformNavDataForLabels("BI08").then(title => {
            setPageTitle(title);
        });

    }, []);





    return (<>
        <div className="main-content">
            {showProcessLoader && <ProcessLoader />}
            {showOptions ?
                <ReportOptions title={pageTitle} >
                    <div className="report-option-wrapper">
                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label>Division</label>
                                <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => {
                                    setSelectedDIV(newVal); loadProductItems(newVal, SelectedYear);
                                    loadGroupList(newVal, SelectedYear);

                                }} />
                            </div>

                            <div className="report-option-item ml-20">
                                <label className="mr-16">Branch</label>
                                <DropDownControl data={allIndiaTypeDepo} id="report_branch_list" name="report_branch_list"

                                    onChange={handleBranchChange}
                                />
                            </div>

                        </div>
                        <div className="report-option-row">
                            <div className="report-option-item ">
                                <label>Mkt&nbsp;Year</label>
                                <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => {
                                    console.log(newYear); loadGroupList(SelectedDiv, newYear); setSelectedYear(newYear); loadProductItems(SelectedDiv, newYear);
                                    loadGroupList(SelectedDiv, newYear);

                                }} />

                            </div>

                            <div className="report-option-item ml-20">
                                <label>From</label>
                                <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                            </div>
                            <div className="report-option-item ml-10">
                                <label>To</label>
                                <DropDownControl data={month_data.data} id="report_endyear_list" name="report_endyear_list" selectedValue={SelectedEndMonth} onChange={(val) => { console.log(val); setSelectedEndMonth(val) }} />
                            </div>

                        </div>
                        <div className="report-option-row">
                            <div className="report-option-item">
                                <input type="radio" class="js-switched mr-10" id="opt_type_1" name="ropt_type" checked={(true && OPT === 1)}
                                    onChange={(e) => { setOPT(1);; }} />
                                <label htmlFor="opt_type_1">H.Q.</label>
                            </div>

                            <div className="report-option-item ml-14">
                                <input type="radio" class="js-switched mr-10" id="opt_type_4" name="ropt_type" checked={(true && OPT === 4)}
                                    onChange={(e) => { setOPT(4); }} />
                                <label htmlFor="opt_type_4">Branch</label>
                            </div>
                        </div>


                        <div className="report-option-row">
                            <div className="report-option-item">

                                <label htmlFor="report_type_1">Report&nbsp;Type</label>
                                <DropDownControl
                                    onChange={(newVal) => {
                                        setReportType(newVal); if (newVal == 9 || newVal == 10 || newVal == 13) { setUnitValue(2); } else {
                                            setUnitValue(1);
                                        }
                                    }}
                                    id="dd_select_report_type"
                                    name="dd_select_report_type"
                                    data={[
                                        { name: "Gross", value: 1 },
                                        { name: "Tot Credit", value: 2 },
                                        { name: "Expiry", value: 3 },
                                        { name: "Salable", value: 4 },
                                        { name: "Brk/Spoiled", value: 5 },
                                        { name: "Net", value: 6 },
                                        { name: "Target", value: 7 },
                                        { name: "Last Year Sale", value: 8 },
                                        { name: "Achievement", value: 9 },
                                        { name: "Growth", value: 10 },
                                        { name: "PMR", value: 11 },
                                        { name: "Field Strength", value: 12 },
                                        { name: "Expiry Ratio", value: 13 }
                                    ]}
                                    selectedValue={ReportType}
                                />



                            </div>

                        </div>



                        <div className="report-option-row">
                            <div className="report-option-item">
                                <input
                                    type="radio"
                                    className="js-switched mr-10"
                                    disabled={ReportType == 9 || ReportType == 10 || ReportType == 13}
                                    name="report_uv"
                                    checked={unitValue === 1}
                                    onChange={() => setUnitValue(1)}
                                />

                                <label>Unit</label>
                            </div>
                            <div className="report-option-item ml-14">
                                <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 2)}
                                    onChange={(e) => { setUnitValue(2); }} />
                                <label>Value</label>
                            </div>

                            <div className="report-option-item ml-14">
                                <input type="radio" class="js-switched mr-10" name="report_uv" checked={(true && unitValue === 3)}
                                    disabled={ReportType == 9 || ReportType == 10 || ReportType == 13}
                                    onChange={(e) => { setUnitValue(3); }} />
                                <label>Both</label>
                            </div>
                        </div>


                        <div className="report-option-row">
                            <div className="report-option-item">
                                <input type="radio" class="js-switched mr-10" name="report_uv2" checked={(true && GroupwiseProductWiseOpt === 1)}
                                    onChange={(e) => { setGroupwiseProductWiseOpt(1);; handleProductChange([]) }} />
                                <label>Productwise</label>
                            </div>
                            <div className="report-option-item ml-14" style={{ marginLeft: "12px" }}>
                                <input type="radio" class="js-switched mr-10" name="report_uv2" checked={(true && GroupwiseProductWiseOpt === 2)}
                                    onChange={(e) => { setGroupwiseProductWiseOpt(2); handleProductChange([]) }} />
                                <label>Groupwise</label>
                            </div>


                        </div>

                        {GroupwiseProductWiseOpt == 1 &&
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label >Select&nbsp;Product</label>
                                    {productlistLoading ? <BrandedLoader /> :
                                        <MultiSelectOptions
                                            itemsData={productListItems}
                                            onChange={handleProductChange}
                                        />}

                                </div>
                            </div>
                        }
                        {GroupwiseProductWiseOpt == 2 &&
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label >Select&nbsp;Group</label>
                                    {groupLoader ? <BrandedLoader /> :
                                        <MultiSelectOptions
                                            itemsData={GroupListItems}
                                            onChange={handleProductChange}
                                        />}

                                </div>
                            </div>
                        }

                        <div className="report-option-action-row">
                            <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                            <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                        </div>
                    </div>
                </ReportOptions>
                :
                <>
                    <div className="row">
                        <div className="col-12">
                            <div className="card report-card" style={{ width: "auto" }}>
                                <div className="card-title report-card-title">{pageTitle}
                                    <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                                </div>
                                <div className="card-body card-body-multireport">


                                    <ul class="nav nav-tabs nav-tabs-light-mode nav-justified" role="tablist">

                                        {SelectedProductCodes.map((product, index) => (

                                            <li key={product.value} class="nav-item ">
                                                <a class={`nav-link ${index == 0 && 'active'}`} onClick={() => { handleTabChange(product.value) }} data-toggle="tab" href={`#tab${product.value}`} role="tab">{product.label}</a>
                                            </li>

                                        ))}

                                    </ul>

                                    <div class="tab-content">
                                        {SelectedProductCodes.map((product, index) => (

                                            <div key={product.value} className={`tab-pane fade ${index == 0 && 'active show'}`} id={`tab${product.value}`}>

                                                {
                                                    tabLoader.includes(product.value) ?

                                                        <>
                                                            <h3 className="fs-16 fw-500">{getTabreport(product.value).title}</h3>

                                                            {getTabreport(product.value).data.length > 0 ? <DynamicDTFloatTabs
                                                                tableID={`tabledt_${product.value}`}
                                                                tableData={getTabreport(product.value)}
                                                                firstColWidth="220px"
                                                                secColWidth="auto"
                                                                handleExportSheet={handleExportSheet}
                                                                fixedColumns={true}
                                                                forceDecimal={getTabreport(product.value).decimal_keys?.length > 0}
                                                                decimalKeys={getTabreport(product.value).decimal_keys}
                                                            /> : <p className="alert alert-secondary" role="alert">No data for this product.</p>}

                                                        </>
                                                        : <BrandedLoader />
                                                }


                                            </div>
                                        ))}


                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </>
            }


        </div>

    </>);
}

export default BI08;